(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumDefaultMessageDeleteController',RptCompendiumDefaultMessageDeleteController);

    RptCompendiumDefaultMessageDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptCompendiumDefaultMessage'];

    function RptCompendiumDefaultMessageDeleteController($uibModalInstance, entity, RptCompendiumDefaultMessage) {
        var vm = this;

        vm.rptCompendiumDefaultMessage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptCompendiumDefaultMessage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
